import { MessageTypeEnum } from '@/common/enum/MessageTypeEnum'
import { channelTypes } from '@/modules/campaign-manage/enum/Labels'

// same as Campaign::RATE_LIMIT_MESSAGE_TYPES
const rateLimitMessageTypes = Object.freeze([
  MessageTypeEnum.PUSH_IOS,
  MessageTypeEnum.PUSH_ANDROID,
  MessageTypeEnum.PUSH_WEB,
  MessageTypeEnum.EMAIL,
  MessageTypeEnum.SMS,
  MessageTypeEnum.WEBHOOK
])

// campaign channel attribute (ios_push, email, ...) by message type
const channelByMessageType = Object.freeze(
  Object.keys(channelTypes).reduce((result, channel) => {
    result[channelTypes[channel]] = channel
    return result
  }, {})
)

export { rateLimitMessageTypes, channelByMessageType }



// WEBPACK FOOTER //
// ./src/modules/campaign-manage/enum/RateLimitEnum.js